/** @description generic validate function */
export default function validate(gluValue, { validate, values }) {
  if (!validate(gluValue, values)) {
    return 'This field is invalid';
  }

  return null;
}
